<template>
    <div  class="card">
        <div class="card-header">사용자 등록</div>
        <div class="card-body">
            <div>
                <form id="insertForm" method="post" enctype="multipart/form-data" Content-Type="application/json" >
                    <div class="form-body">
                        <div>
                            <h3 class="form-title">로그인 정보</h3>
                            <div class="row">
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">Login ID*</span>
                                        <input type="text" class="form-control checkRequired checkBlank" v-model="form.usrId" name="usrId" ref='usrId'
                                        placeholder="아이디" title="아이디" v-on:mousedown="removeClass('usrId',['is-invalid','is-valid'])">
                                        <button type="button" class="btn btn-info" style="width: 100px;" v-on:click="checkUserIdDuplicate()">중복확인</button>
                                    </div>
                                </div>
                                <div  class="badge  alert alert-success" role="alert">{{userIdDuplicateMessage}}</div>
                                <!-- <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">제휴사*</span>
                                        <select class="form-control checkRequired" name="valuedation" v-model="form.coalitionCompany">
                                            <option value="" selected>--제휴사 선택--</option>
                                            <option v-for="(coalitionCompanyList, index) in selectBox.coalitionCompanyList" :key="index" :value="coalitionCompanyList.idx">{{coalitionCompanyList.name}}</option>
                                        </select>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row">
                                <div class="form-group col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">비밀번호*</span>
                                        <input type="password" class="form-control checkRequired checkBlank" v-model="form.usrPwd" name="valuedation" ref='usrPwd'
                                        v-on:mousedown="removeClass('usrPwd',['is-invalid'])" placeholder="비밀번호" title="비밀번호">
                                    </div>
                                </div>
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">비밀번호확인*</span>
                                        <input type="password" class="form-control checkRequired checkBlank" v-model="form.usrPwdCheck" name="valuedation"
                                        ref='usrPwdCheck' v-on:mousedown="removeClass('usrPwdCheck',['is-invalid'])" placeholder="비밀번호확인" title="비밀번호확인">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="my-4">
                        <div>
                            <h3 class="form-title">개인 정보</h3>
                            <div class="row">
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">이름*</span>
                                        <input type="text" class="form-control checkRequired checkBlank" v-model="form.usrNam"
                                        name="valuedation" ref='usrNam' v-on:mousedown="removeClass('usrNam',['is-invalid'])" placeholder="담당자명" title="담당자명">
                                    </div>
                                </div>
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">휴대전화</span>
                                        <input type="text" class="form-control checkTelephone" v-model="form.phone"
                                        name="valuedation" ref='phone' v-on:mousedown="removeClass('phone',['is-invalid'])" placeholder="휴대전화" title="휴대전화">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">회사이름*</span>
                                        <input type="text" class="form-control checkRequired checkBlank" v-model="form.cpyNam"
                                        name="valuedation" ref='cpyNam' v-on:mousedown="removeClass('cpyNam',['is-invalid'])" placeholder="회사이름" title="회사이름">
                                    </div>
                                </div>
                                <div class="form-group  col-lg-5">
                                    <div class="input-group">
                                        <span class="input-group-text" style="width:18%">이메일</span>
                                        <input type="text" class="form-control" v-model="form.email"
                                        name="valuedation" ref='email' v-on:mousedown="removeClass('email',['is-invalid'])" placeholder="이메일" title="이메일">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </form>
                    <div class="row" style="justify-content: flex-end;">
                        <div>
                            <button type="button" class="btn btn-success" style="width: 100px;" v-on:click="insertUser">등록</button>
                        </div>
                        <div style="width: 20px;"></div>
                        <div>
                            <button type="button" class="btn btn-secondary" style="width: 100px;" v-on:click="close">취소</button>
                        </div>
                    </div>
                </div>
        </div>
    </div>

</template>

<script>
// import router from '@/router';
import axios from 'axios';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import pathDefine from '@IM_node_modules/js/pathDefine.js'
import {isValidate} from '@IM_node_modules/js/common/validateCheck.js'

  export default {
    data() {
      return {
        form: {
            usrId:'',
            usrPwd:'',
            usrPwdCheck:'',
            usrNam:'',
            phone:'',
            email:'',
            cpyNam:'',
            },
        userIdDuplicate:null,
        userIdDuplicateMessage:'',
        selectBox:
        {
            coalitionCompanyList:[],
        },
      }
    },

    methods:
    {
        //작성일:2020-04-27
        //1.개요:아이디 중복체크 하여 userIdDuplicate에 값을 입력한다.
        //2.결과물:true:중복값이 있다. false:중복값이 없다.
        checkUserIdDuplicate()
        {
            let data = this;
            var mUserId = data.form.usrId;
            data.userIdDuplicateMessage = '';
            data.userIdDuplicate = true;
            //대문자를 소문자로 변환
            data.form.usrId.toLowerCase();

            if(isValidate([this.$refs['usrId']]))return;

            //아이디 특수문자 Validation
            var specialPattern = /[~!@#$%^&*()+|<>?:{}]/;
            if( specialPattern.test(mUserId) == true )
            {
                alert('특수문자 사용할 수 없습니다.');
                this.$refs['usrId'].classList.add('is-invalid')
                return false;
            }

            //아이디 4자이상 Validation
            if(mUserId.length < 4)
            {
                alert("아이디는 4자 이상입니다.")
                this.$refs['usrId'].classList.add('is-invalid')
                return false;
            }
            const formData = new FormData();
            formData.append('usrId',data.form.usrId);

            axios.post(pathDefine.apiUrl.system.userIdCheck,formData
            ).then((response)=>
              {
                  console.log(response);
                  if(response.data.result_string == 'N')
                  {
                      alert("아이디가 중복되었습니다")
                      this.$refs['usrId'].classList.add('is-invalid')
                      data.userIdDuplicate = true
                  }
                  else
                  {
                      this.$refs['usrId'].classList.add('is-valid')
                      data.userIdDuplicateMessage = '아이디 사용이 가능합니다.'
                      data.userIdDuplicate = false
                  }
              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .then(function () {
                // always executed
              });
        },
        //작성일:2020-04-27
        //1.개요:대표계정을 신청하는 메소드
        insertUser()
        {
            const formData = new FormData();
            formData.append('usrId',this.form.usrId);
            formData.append('usrPwd',this.form.usrPwd);
            formData.append('usrNam',this.form.usrNam);
            formData.append('phone',this.form.phone);
            formData.append('email',this.form.email);
            formData.append('cpyNam',this.form.cpyNam);

            if(this.checkValidation())
            {
                //아이디 중복체크
                if(this.userIdDuplicate == true || this.userIdDuplicate == null)
                {
                    alert("아이디를 중복체크 바랍니다.")
                    this.$refs['usrId'].classList.add('is-invalid')
                    return
                }
                axios.post(pathDefine.apiUrl.system.insertInfo,formData)
                  .then((response)=>
                  {
                      console.log(response);
                      if(response.data.respFlag)
                      {
                          alert('등록에 성공하였습니다')
                          this.close();
                      }
                      else
                      {
                          alert('등록에 실패하였습니다')
                      }
                  })
                  .catch(function (error) {
                    // handle error
                    console.log(error);
                  })
                  .then(function () {
                    // always executed
                  });
            }
        },
        //작성일:2020-04-27
        //1.개요:아이디 및 비밀번호 입력값 체크하여 true/false리턴하는 메소드
        checkValidation()
        {
            let dataForm = this.form;
            var mPassword = dataForm.usrPwd;

            if(isValidate(document.getElementsByName('valuedation')))return;


            //비밀번호 4자이상 Validation
            if(mPassword.length < 4)
            {
                alert("비밀번호는 4자 이상입니다.")
                this.$refs['usrPwd'].classList.add('is-invalid')
                return false
            }

            //비밀번호확인 체크 Validation
            if(mPassword != dataForm.usrPwdCheck)
            {
                alert("비밀번호와 비밀번호 확인이 일치하지 않습니다.")
                this.$refs['usrPwd'].classList.add('is-invalid')
                this.$refs['usrPwdCheck'].classList.add('is-invalid')
                return false
            }

            return true;
        },

        //작성일:2020-05-11
        //1.개요:클래스를 찾아 원하는 클래스로 변경하는 메소드
        //2.멤버변수: beforeClass-찾을려는 클래스,afterClass-바꿀 클래스
        changeClassName(beforeClass,afterClass)
        {
            var classAraay = document.getElementsByClassName(beforeClass);
            var Araaylength = classAraay.length;
            for(var i = 0; i<Araaylength; i++)
            {
                classAraay[0].className = afterClass;
            }

        },
        //작성일:2020-05-12
        //1.개요:닫기버튼 클릭시 로그인 페이지로 이동하는 메소드
        close: function ()
        {
            location.href = "/login.do"
        },
        //작성일:2020-06-11
        //1.개요:태그에 특정 class를 제거하는 메소드
        //2.input: name-해당 태그에 ref값, className-제거할 class
        removeClass(name,className)
        {
            var classNameArray = className
            for(var i=0; i<classNameArray.length; i++)
            {
                this.$refs[name].classList.remove(classNameArray[i])
            }
        },

    },
    created: function()
    {
    },


  }
</script>